import { getList } from '@/api/course'


export default {
    name: 'list',
    data() {
        return {
            courses: [],
            images: [
                require('@/assets/banner1.png'),
                require('@/assets/banner2.png'),
                require('@/assets/banner3.png'),
                require('@/assets/banner4.png'),
              ],
        }   
    },

    methods: {

    },

    mounted() {
        const that = this;

        getList().then(res => {
            console.log(res);
            that.courses = res.data;
        }).catch(rej => {
            console.log(rej);
            that.$router.replace('/login')
        })
    }
}